import { useContext } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { AuthContext } from 'src/contexts/AuthContext';
import { logoutService } from 'src/services/auth';

const useLogout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { isLoading, mutateAsync, isError } = useMutation(
    () => logoutService(),
    {}
  );

  const logoutMutation = async () => {
    try {
      const response = await mutateAsync();
      if (response.status === 200) {
        const { data } = response;
        console.log(data);
        logout();
        navigate('/login', { replace: true });
      }
    } catch (error: any) {
      console.log(error);
      // toast.error(error.message || 'An error occurred');
      logout();
      navigate('/login', { replace: true });
    }
  };

  return { isLoading, logoutMutation, isError };
};

export default useLogout;
